import TagsMultiSelect from "../TagsMultiSelect.tsx";
import { TagRelationType } from "../TagsMultiSelect.types.ts";
import { useTagsMultiSelectAutoUpdater } from "./TagsMultiSelectAutoUpdater.hooks.ts";

export interface TagsMultiSelectStandAloneProps {
    entityId: string;
    isLoading: boolean;
    entityType: TagRelationType;
    variant?: "standard" | "outlined";
    disabled?: boolean;
    displayOnlyAsChips?: boolean;
    hideLabel?: boolean;
    noMargin?: boolean;
    placeHolder?: string;
    tooltipText?: string;
    errorText?: string;
    disableQuery?: boolean;
    emptyText?: string;
}

function TagsMultiSelectAutoUpdater(props: TagsMultiSelectStandAloneProps) {
    const { selectedTags, onAddTagRelation, onRemoveTagRelation, isLoading, onRemoveAllRelationsFromEntity } = useTagsMultiSelectAutoUpdater(
        props.entityId,
        props.entityType,
        props.disableQuery ?? false
    );

    return (
        <TagsMultiSelect
            selectedTags={selectedTags}
            onTagAdded={onAddTagRelation}
            onTagRemoved={onRemoveTagRelation}
            isLoading={isLoading || props.isLoading}
            entityType={props.entityType}
            variant={props.variant}
            disabled={props.disabled}
            noMargin={props.noMargin}
            displayOnlyAsChips={props.displayOnlyAsChips}
            hideLabel={props.hideLabel}
            placeHolder={props.placeHolder}
            onChange={(tags) => {
                if (selectedTags.length > 1 && tags.length === 0) {
                    onRemoveAllRelationsFromEntity();
                }
            }}
            tooltipText={props.tooltipText}
            errorText={props.errorText}
            disableQuery={props.disableQuery}
            emptyText={props.emptyText}
        />
    );
}

export default TagsMultiSelectAutoUpdater;
